module.exports = __webpack_public_path__ + "static/telefonika-6eb88673cbd0c0a6741446d7a8f846f0.png";